import React, {useCallback, useState, useEffect, useRef, useContext} from 'react';

import { useStaticQuery, graphql } from 'gatsby';
import { Box, Dialog, IconButton, SvgIcon } from '@mui/material';
import store from "store2";

import { Link } from "gatsby";
import { ApplicationContext } from "@product-site-frontend/shared/index";

export default function BannerAuto() {
    const bannersData = useStaticQuery(graphql`
        query BannersQuery {
            home: strapiHome {
                banners {
                    name
                    url
                    imageDesktop {
                        id
                        alternativeText
                        caption
                        localFile {
                            childImageSharp {
                                gatsbyImageData(quality: 100, layout: FULL_WIDTH)
                            }
                        }
                    }
                    imageMobile {
                        id
                        alternativeText
                        caption
                        localFile {
                            childImageSharp {
                                gatsbyImageData(quality: 100, layout: FULL_WIDTH)
                            }
                        }
                    }
                    isActive
                }
            }
        }
    `);

    const { data: applicationContext } = useContext(ApplicationContext);

    const { applicationOpen } = applicationContext;

    const arenzaStorage = store.namespace('arenza');

    const [notShownBanner, setNotShownBanner] = useState(null);
    const [showDialog, setShowDialog] = useState(false);

    const timeoutId = useRef(undefined);

    const handleDialogOpen = useCallback((banner) => {
        if (banner) {
            setShowDialog(true);
            arenzaStorage(banner.name, true);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [notShownBanner]);

    const handleDialogClose = () => {
        setShowDialog(false);
    };

    const getImageFromStrapiObject = (image) => {
        if(Array.isArray(image)) {
            return image[0].localFile.childImageSharp.gatsbyImageData.images.fallback.src;
        } else if(image) {
            return image.localFile.childImageSharp.gatsbyImageData.images.fallback.src;
        }

        return '';
    };

    useEffect(() => {
        if (applicationOpen) return;

        const notShownBanners = [];

        if(bannersData?.home?.banners && bannersData?.home?.banners.length > 0) {
            bannersData.home.banners.forEach((element) => {
                if(!arenzaStorage(element.name) && element.isActive) {
                    notShownBanners.push(element);
                }
            });
        }

        if(notShownBanners.length > 0) {
            const randomId = Math.floor(Math.random() * notShownBanners.length);
            setNotShownBanner(notShownBanners[randomId]);
            timeoutId.current = setTimeout(() => {handleDialogOpen(notShownBanners[randomId])}, 10000);
        }

        return () => {
            if (timeoutId.current) {
                clearTimeout(timeoutId.current);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [applicationOpen]);

    if (showDialog && notShownBanner) {
        return (
            <Dialog
                fullWidth={true}
                maxWidth="lg"
                onClose={handleDialogClose}
                open={true}
                sx={{
                    '& .MuiDialog-paper': {
                        maxWidth: {
                            xs: '326px',
                            // sm: '426px',
                            md: '897px'
                        },
                        borderRadius: '33px',
                        minHeight: {
                            xs: '497px',
                            // sm: '222px',
                            md: '423px',
                        },
                        backgroundImage: {
                            xs: `url("${getImageFromStrapiObject(notShownBanner.imageMobile)}")`,
                            // sm: `url("${popupImageSm}")`,
                            md: `url("${getImageFromStrapiObject(notShownBanner.imageDesktop)}")`
                        },
                        backgroundPosition: {
                            xs: 'top center',
                            md: 'center left',
                            lg: 'center left'
                        },
                        backgroundSize: {
                            xs: 'contain',
                            sm: 'cover'
                        },
                        backgroundColor: '#1c2b4d',
                        backgroundRepeat: 'no-repeat'
                    }
                }}
            >
                <Link to={notShownBanner.url}>
                    <Box sx={{
                        display: 'block',
                        minHeight: {
                            xs: '500px',
                            md: '423px'
                        }
                    }} />
                </Link>

                <IconButton aria-label="close" onClick={handleDialogClose} sx={{
                    position: 'absolute',
                    top: '14px',
                    right: '14px',
                    background: 'rgba(13, 29, 50, 0.24)',
                    borderRadius: '50%'
                }}>
                    <SvgIcon>
                        <path clipRule="evenodd" d="M5.70735 4.29288C5.31683 3.90235 4.68366 3.90235 4.29314 4.29288C3.90261 4.6834 3.90261 5.31657 4.29314 5.70709L10.5878 12.0017L4.29333 18.2961C3.9028 18.6867 3.9028 19.3198 4.29333 19.7104C4.68385 20.1009 5.31702 20.1009 5.70754 19.7104L12.002 13.4159L18.2964 19.7104C18.6869 20.1009 19.3201 20.1009 19.7106 19.7104C20.1011 19.3198 20.1011 18.6867 19.7106 18.2961L13.4162 12.0017L19.7108 5.70709C20.1013 5.31657 20.1013 4.6834 19.7108 4.29288C19.3203 3.90235 18.6871 3.90235 18.2966 4.29288L12.002 10.5875L5.70735 4.29288Z" fill="#fff" fillRule="evenodd" />
                    </SvgIcon>
                </IconButton>
            </Dialog>
        );
    }

    return '';
}
